export enum UserRoleName {
  SuperAdmin = 'superadmin',
  AdminDispatcher = 'admindispatcher',
  Dispatcher = 'dispatcher',
  Driver = 'driver',
}
